import LogoCropper from './LogoCropper';

export default LogoCropper;
